import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import { Link } from 'react-router-dom'
import NewMain from '../headerone/newMain'
import NewIqacSidebar from './NewIqacSidebar'

function SDG() {
  return (
    <>
    <style>{` .footer_main01  { display:none;      } `}</style>
      <div className='new_iqac'>
         
              <div className='row'>
                  <div className='col-md-3'>
                       <NewIqacSidebar />
                  </div>

                  <div className='col-md-9'>
                    <div className='home'>
                        <div className='about'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='text'>
                                        <div className="img">
                                            <img src='/assets/img/sdgimg.png'></img>
                                        </div>
                                        <h3>MVN University</h3>
                                        {/* <label>Report on Best Practices for Sustainable Development Goals
                                        </label> */}
                                        <div className='intro'>
                                            <h4>Introduction</h4>
                                            <p>MVN University committed to promote sustainable development goals (SDGs), as defined by the United Nations, a universal call to action to end poverty, protect the planet, and ensure peace and prosperity for all by 2030. MVN University play a critical role in promoting and implementing these goals through education, research, and campus operations. This report outlines best practices for achieving SDGs in MVN University, with a focus on sustainable infrastructure: Water Treatment Plant (WTP), Sewage Treatment Plant (STP), and Electric Rickshaws for student commuting.
                                            </p>
                                            <br></br>
                                            <h4>1. Water Treatment Plant (WTP)</h4>
                                            <div className='row'>
                                                <div className='col-md-6 col-sm-6 col-xs-12'>
                                                    <div className='goal'>
                                                        <label>Relevant Goals:</label>
                                                        <ul>
                                                            <li>1. SDG 6 (Clean Water and Sanitation)</li>
                                                            <li>2. SDG 12 (Responsible Consumption and Production)</li>
                                                        </ul>
                                                    </div>
                                                    <br />
                                                    <div className='goal'>
                                                        <label>Details:</label>
                                                        <ul>
                                                            <li>1. Centralized water treatment facilities.</li>
                                                            <li>2. Regular monitoring of water quality using digital sensors and lab testing to meet BIS and WHO standards.
                                                            </li>
                                                            <li>3. Promotion of water reuse, particularly in cooling systems and landscaping, to reduce freshwater consumption.</li>
                                                            <li>4. Rainwater harvesting systems integrated with the WTP to recharge groundwater and supplement water sources.</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className='col-md-6 col-sm-6 col-xs-12'>
                                                    <div className="imgs">
                                                        <img src='/assets/img/wtp.png'></img>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <br></br>
                                            <h4>2. Sewage Treatment Plant (STP)</h4>
                                            <div className='row'>
                                                <div className='col-md-6 col-sm-6 col-xs-12'>
                                                    <div className='goal'>
                                                        <label>Relevant Goals:</label>
                                                        <ul>
                                                            <li>1. SDG 6 (Clean Water and Sanitation),</li>
                                                            <li>2. SDG 11 (Sustainable Cities and Communities),</li>
                                                            <li>3. SDG 13 (Climate Action)</li>
                                                        </ul>
                                                    </div>
                                                    <br />
                                                    <div className='goal'>
                                                        <label>Details:</label>
                                                        <ul>
                                                            <li>1. Modern STP installation with biological and tertiary treatment, ensuring treated effluent is safe for reuse.
                                                            </li>
                                                            <li>2. Utilization of treated wastewater for flushing, gardening, and construction purposes within the campus.
                                                            </li>
                                                            <li>3. Automation of the treatment process with SCADA systems to improve operational efficiency and minimize manual errors.
                                                            </li>
                                                            <li>4. Sludge management system for composting and organic fertilizer generation.</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className='col-md-6 col-sm-6 col-xs-12'>
                                                    <div className="imgs">
                                                    <img src='/assets/img/stp.png'></img>
                                                    </div>
                                                </div>
                                            </div>
                                          
                                            
                                            <br></br>
                                            <h4>3. Electric Rickshaws for Campus Commute</h4>
                                            <div className='row'>
                                                <div className='col-md-6 col-sm-6 col-xs-12'>
                                                    <div className='goal'>
                                                        <label>Relevant Goals:</label>
                                                        <ul>
                                                            <li>1. SDG 11 (Sustainable Cities and Communities),</li>
                                                            <li>2. SDG 13 (Climate Action)</li>
                                                        </ul>
                                                    </div>
                                                    <br />
                                                    <div className='goal'>
                                                        <label>Details:</label>
                                                        <ul>
                                                            <li>1. Deployment of electric rickshaws for intra-campus transportation to provide safe and sustainable mobility options for students and staff.
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className='col-md-6 col-sm-6 col-xs-12'>
                                                    <div className="imgs">
                                                    <img src='/assets/img/rickshaws.png'></img>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                    </div>
                  </div>


              </div>

         

      </div>

    </>
  )
}

export default SDG